import React, { useState } from "react";

function DeleteTileModal({ tiles, onDelete, onCancel }) {
  const [selectedTileId, setSelectedTileId] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selectedTile, setSelectedTile] = useState(null);
  const [viewingTile, setViewingTile] = useState(null);
  
  // Get current user from localStorage
  const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
  
  // Filter tiles based on user permissions
  // Admin users (both saifazim and claireoh) can only delete their own tiles
  const deletableTiles = tiles.filter(tile => {
    // Only show tiles created by the current user
    return tile.createdBy?.username === user.username || tile.createdBy?._id === user.id;
  });

  const handleTileSelect = (tile) => {
    setSelectedTile(tile);
    setShowConfirmation(true);
  };

  const handleTileView = (tile) => {
    setViewingTile(tile);
  };

  const handleConfirmDelete = () => {
    onDelete(selectedTile);
    setShowConfirmation(false);
    setSelectedTile(null);
  };

  const handleCancelDelete = () => {
    setShowConfirmation(false);
    setSelectedTile(null);
  };

  const handleBackFromView = () => {
    setViewingTile(null);
  };

  if (viewingTile) {
    return (
      <div
        className="delete-tile-modal journal-view "
        style={{
          // backgroundColor: "rgba(138, 79, 255, 0.1)",
          borderColor: "#8A4FFF",
          // backdropFilter: "blur(10px)",
          // WebkitBackdropFilter: "blur(10px)",
        }}
      >
        <h1 className="journal-title">{viewingTile.title}</h1>

        {/* Media Display */}
        {viewingTile.media && viewingTile.media.url && (
          <div className="journal-media-container">
            {viewingTile.media.type === "image" ? (
              <img
                src={viewingTile.media.url}
                alt={viewingTile.title}
                className="journal-image"
              />
            ) : (
              <video controls className="journal-video">
                <source src={viewingTile.media.url} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}
          </div>
        )}

        {/* Description */}
        <div className="journal-description-container">
          <p className="journal-description">{viewingTile.description}</p>
        </div>

        <div className="editor-buttons">
          <button
            type="button"
            className="cancel-button"
            onClick={handleBackFromView}
          >
            Back
          </button>
        </div>
      </div>
    );
  }

  if (showConfirmation) {
    return (
      <div
        className="delete-confirmation"
        style={{
          backgroundColor: "rgba(138, 79, 255, 0.1)",
          borderColor: "#8A4FFF",
        }}
      >
        <h2>Confirm Delete</h2>
        <p>Are you sure you want to delete the tile "{selectedTile.title}"?</p>

        <div className="editor-buttons">
          <button
            type="button"
            className="cancel-button"
            onClick={handleCancelDelete}
          >
            No
          </button>
          <button
            type="button"
            className="delete-button"
            onClick={handleConfirmDelete}
          >
            Yes
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      className="delete-tile-modal"
      style={{
        backgroundColor: "rgba(138, 79, 255, 0.1)",
        borderColor: "#8A4FFF",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
      }}
    >
      <h2>Select Tile to Delete</h2>

      {deletableTiles.length === 0 ? (
        <p className="no-tiles-message">No tiles available to delete. You can only delete tiles you created.</p>
      ) : (
        <ul className="tile-list">
          {deletableTiles.map((tile, index) => (
            <li key={index} className="tile-list-item">
              <span className="tile-list-title">{tile.title}</span>
              <div className="tile-list-actions">
                {/* <button
                  type="button"
                  className="view-button"
                  onClick={() => handleTileView(tile)}
                >
                  View
                </button> */}
                <button
                  type="button"
                  className="delete-list-button"
                  onClick={() => handleTileSelect(tile)}
                >
                  Delete
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}

      <div className="editor-buttons">
        <button type="button" className="cancel-button" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
}

export default DeleteTileModal;
